// extracted by mini-css-extract-plugin
export var header = "header-module--header--9422c";
export var headerCollapsed = "header-module--headerCollapsed--c866b";
export var headerContent = "header-module--headerContent--19ded";
export var headerMobile = "header-module--headerMobile--91fb5";
export var lang = "header-module--lang--85b53";
export var langSelector = "header-module--langSelector--3a606";
export var langSelectorCollapsed = "header-module--langSelectorCollapsed--d72fe";
export var linkElement = "header-module--linkElement--3180c";
export var linkElementContainer = "header-module--linkElementContainer--72868";
export var linksContainer = "header-module--linksContainer--1c838";
export var logo = "header-module--logo--3c90d";
export var logoContainer = "header-module--logoContainer--bdc81";
export var searchBar = "header-module--searchBar--4e89f";
export var searchForm = "header-module--searchForm--a6e64";
export var sideButton = "header-module--sideButton--ea04b";
export var sideButtonCollapsed = "header-module--sideButtonCollapsed--22009";
export var sideLink = "header-module--sideLink--42bd6";
export var slideIn = "header-module--slideIn--420e9";
export var websiteContent = "header-module--websiteContent--e6909";
export var websiteContentCollapsed = "header-module--websiteContentCollapsed--e8a2d";
export var websiteSettingsAndSearchCollapsed = "header-module--websiteSettingsAndSearchCollapsed--aebae";
export var websiteSettingsAndSearchNonCollapsed = "header-module--websiteSettingsAndSearchNonCollapsed--6d98c";